import http from '@/http';
import requestUrlFunction from '@/utils/requestUrl';
import eventBus from '@/utils/eventBus';
import cancelRequest from '@/utils/cancelRequest';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async searchDealers(context, params) {
      let requestUrl = requestUrlFunction(params);
      requestUrl += `&searchTerm=${encodeURIComponent(params.searchTerm || '')}`;
      if (params.admin) {
        requestUrl += '&admin=true';
      }
      if (params.includeAdministrators) {
        requestUrl += '&includeAdministrators=true';
      }
      if (params.organizationIds) {
        requestUrl += `&organizationIds=${params.organizationIds.join(',')}`;
      }

      const response = await http.get(`dealers/${requestUrl}`, cancelRequest(null, params));

      return response;
    },
    // async searchDealers(context, params) {
    //   let requestUrl = requestUrlFunction(params);
    //   requestUrl += `&searchTerm=${encodeURIComponent(params.searchTerm || '')}`;

    //   const response = await http.get(`dealers/${requestUrl}`, cancelRequest(null, params));

    //   return response;
    // },
    async getDealer(context, id) {
      const response = await http.get(`dealers/${id}`);

      return response;
    },
    async createDealer(context, dealer) {
      // let response = await context.dispatch('validateDealerCertificate', dealer);
      let response = {};
      if (dealer.certificateFile) {
        response = await context.dispatch('validateDealerCertificate', dealer);

        if (response.data && response.data.certificateValid) {
          response = await http.post('dealers/', {
            firstName: dealer.firstName,
            lastName: dealer.lastName,
            email: dealer.email,
            phone: dealer.phone,
            organizationId: dealer.organizationId,
            limitForAddedDealers: dealer.limitForAddedDealers,
          });

          if (response.status === 200 && dealer.certificateFile) {
            dealer.id = response.data.id; // eslint-disable-line no-param-reassign
            await context.dispatch('uploadDealerCertificate', dealer);
          }
        } else {
          eventBus.$emit(
            'error400',
            {
              message: response.data.localizedMessage || 'Nevalidní certifikát',
            },
          );
          throw new Error(response);
        }
        return response;
      }
      response = await http.post('dealers/', {
        firstName: dealer.firstName,
        lastName: dealer.lastName,
        email: dealer.email,
        phone: dealer.phone,
        organizationId: dealer.organizationId,
        limitForAddedDealers: dealer.limitForAddedDealers,
      });

      return response;
    },
    async updateDealerAndUploadDealerCertificate(context, dealer) {
      let response = {};
      if (dealer.certificateFile) {
        response = await context.dispatch('validateDealerCertificate', dealer);

        if (response.data && response.data.certificateValid) {
          response = await context.dispatch('updateDealer', dealer);

          if (response.status === 200) {
            await context.dispatch('uploadDealerCertificate', dealer);
          }
        } else {
          eventBus.$emit(
            'error400',
            {
              message: response.data.localizedMessage || 'Nevalidní certifikát',
            },
          );
          throw new Error(response);
        }
        return response;
      }
      response = await context.dispatch('updateDealer', dealer);

      return response;
    },
    async updateDealer(context, dealer) {
      const response = await http.put(`dealers/${dealer.id}`, {
        firstName: dealer.firstName,
        lastName: dealer.lastName,
        email: dealer.email,
        phone: dealer.phone,
        organizationId: dealer.organizationId,
        limitForAddedDealers: dealer.limitForAddedDealers,
      });

      return response;
    },
    async validateDealerCertificate(context, dealer) {
      const formDataFile = new FormData();
      formDataFile.append('file', dealer.certificateFile);
      const response = await http.post('dealers/validate-certificate', formDataFile);

      return response;
    },
    async uploadDealerCertificate(context, dealer) {
      const formDataFile = new FormData();
      formDataFile.append('file', dealer.certificateFile);
      const response = await http.post(`dealers/${dealer.id}/certificate`, formDataFile);

      return response;
    },
    async deleteDealer(context, dealer) {
      const response = await http.delete(`dealers/${dealer.id}`);

      return response;
    },
    async setDealerBannedStatus(context, dealer) {
      const response = await http.put(`dealers/${dealer.id}/banned?banned=${!dealer.banned}`);

      return response;
    },
  },
};
